import { ReaderNavigationContext } from "../../screens/reader/types";
import { mapDetailSourceFromNavigation } from "./source";
import { getCurrentArea } from "../../screens/reader/hooks/readerNavigationArea";
import { deriveCanonicalStreamSource } from "../../screens/reader/hooks/readerNavigationStream";

type ResolveEngagementSourceInput = {
  pathname: string;
  slideInNavigationContext?: ReaderNavigationContext;
  trigger?: ReaderNavigationContext["trigger"];
  streamId?: string;
  streamSlug?: string;
  fallbackSource?: string;
};

function buildRouteNavigationContext({
  pathname,
  trigger,
  streamId,
  streamSlug,
}: Omit<
  ResolveEngagementSourceInput,
  "slideInNavigationContext" | "fallbackSource"
>): ReaderNavigationContext | undefined {
  const area = getCurrentArea(pathname, false);
  if (!area && !trigger) {
    return undefined;
  }

  const normalizedStream = deriveCanonicalStreamSource({
    pathname,
    area,
    streamId,
    streamSlug,
  });

  const navigationContext: ReaderNavigationContext = {
    area,
    trigger,
    stream: normalizedStream,
  };

  return navigationContext;
}

export function resolveEngagementSource({
  pathname,
  slideInNavigationContext,
  trigger,
  streamId,
  streamSlug,
  fallbackSource = "others",
}: ResolveEngagementSourceInput): string {
  const sourceContext = slideInNavigationContext
    ? {
        ...slideInNavigationContext,
        trigger: trigger ?? slideInNavigationContext.trigger,
      }
    : buildRouteNavigationContext({
        pathname,
        trigger,
        streamId,
        streamSlug,
      });

  if (!sourceContext) {
    return fallbackSource;
  }

  return mapDetailSourceFromNavigation(sourceContext);
}
